import React, { useCallback, useState } from 'react'

export interface UserInteractiveStateProps {
  hovered: boolean
  mouseDown: boolean
  focused: boolean
}

const withMouseInteractions = <T,>(
  WrappedComponent: React.FC<T>,
): React.FC<T> => {
  const ComponentMouseInteractions = (props: T) => {
    const [hovered, setHovered] = useState(false)
    const [mouseDown, setMouseDown] = useState(false)
    const [focused, setFocused] = useState(false)

    const onPointerEnter = useCallback(() => {
      setHovered(true)
    }, [])

    const onPointerDown = useCallback(() => {
      setMouseDown(true)
    }, [])

    const onPointerUp = useCallback(() => {
      setMouseDown(false)
    }, [])

    const onPointerLeave = useCallback(() => {
      setMouseDown(false)
      setHovered(false)
    }, [])

    const onFocus = useCallback(() => {
      if (!mouseDown) {
        setFocused(true)
      }
    }, [mouseDown])

    const onBlur = useCallback(() => {
      setFocused(false)
    }, [])

    const allProps = {
      ...props,
      hovered,
      mouseDown,
      focused,
      onPointerEnter,
      onPointerDown,
      onPointerLeave,
      onPointerUp,
      onFocus,
      onBlur,
    }
    return <WrappedComponent {...allProps} />
  }

  return ComponentMouseInteractions
}

export default withMouseInteractions
